// Client-side store content translation: applies a {source -> translated} dictionary
// over nested content objects, only to known human-readable fields.
export const TRANSLATABLE_KEYS = new Set([
  "title", "subtitle", "heading", "subheading", "body", "text", "cta_text",
  "button_text", "label", "name", "quote", "author", "caption", "slogan",
  "excerpt", "description", "body_html", "seo_title", "seo_description",
  "tagline", "success_message", "placeholder", "intro", "content", "message",
  "note", "answer", "question", "variant_name",
]);

export function translateDeep(obj, dict) {
  if (!dict || obj == null) return obj;
  if (Array.isArray(obj)) return obj.map((x) => translateDeep(x, dict));
  if (typeof obj === "object") {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      if (TRANSLATABLE_KEYS.has(k) && typeof v === "string" && dict[v] != null) {
        out[k] = dict[v];
      } else {
        out[k] = translateDeep(v, dict);
      }
    }
    return out;
  }
  return obj;
}

export function trStr(s, dict) {
  if (dict && typeof s === "string" && dict[s] != null) return dict[s];
  return s;
}

// Returns the active translation dictionary for the store, or null when the
// display language equals the store's primary (source) language.
export function activeDict(store, displayLang) {
  if (!store) return null;
  const primary = (store.language || "en").toLowerCase();
  const dl = (displayLang || primary).toLowerCase();
  if (dl === primary) return null;
  const d = (store.translations || {})[dl];
  return d && Object.keys(d).length ? d : null;
}
